import { render, staticRenderFns } from "./DoctorListSelect.vue?vue&type=template&id=71e7b7f8&scoped=true"
import script from "./DoctorListSelect.vue?vue&type=script&lang=js"
export * from "./DoctorListSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e7b7f8",
  null
  
)

export default component.exports